import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'DECIDI COSA FARE',
        description:
            "Dopo aver modificato l'esercizio premi 'Elimina' per eliminare definitivamente l'esercizio dal tuo archivio. Premi 'Salva come nuovo' per creare un nuovo esercizio. Premi 'Aggiorna' per sovrascrivere ad una verifica già esistente.",
        isActive: true,
        name: 'EditPageArchiveAnchor',
        tutorialName: 'modifica-esercizi_pulsantiera_archivio'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'top',
        xPlacement: 'CENTER',
        yPlacement: 'MIDDLE'
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'top',
        xOffset: 5
    }
};
